/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_BrowseInputs */

const en_options_cli_browse = /** @type {(inputs: Options_Cli_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse...`)
};

const fr_options_cli_browse = /** @type {(inputs: Options_Cli_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcourir...`)
};

const de_options_cli_browse = /** @type {(inputs: Options_Cli_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchsuchen...`)
};

const it_options_cli_browse = /** @type {(inputs: Options_Cli_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfoglia...`)
};

const ru_options_cli_browse = /** @type {(inputs: Options_Cli_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просматривать...`)
};

const es_options_cli_browse = /** @type {(inputs: Options_Cli_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegar...`)
};

const zh_cn2_options_cli_browse = /** @type {(inputs: Options_Cli_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览...`)
};

const ja_options_cli_browse = /** @type {(inputs: Options_Cli_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウズ...`)
};

const hi_options_cli_browse = /** @type {(inputs: Options_Cli_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्राउज़ करें...`)
};

const pt_pt2_options_cli_browse = /** @type {(inputs: Options_Cli_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegar...`)
};

/**
* | output |
* | --- |
* | "Browse..." |
*
* @param {Options_Cli_BrowseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_browse = /** @type {((inputs?: Options_Cli_BrowseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_BrowseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_browse(inputs)
	if (locale === "de") return de_options_cli_browse(inputs)
	if (locale === "it") return it_options_cli_browse(inputs)
	if (locale === "ru") return ru_options_cli_browse(inputs)
	if (locale === "es") return es_options_cli_browse(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_browse(inputs)
	if (locale === "ja") return ja_options_cli_browse(inputs)
	if (locale === "hi") return hi_options_cli_browse(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_browse(inputs)
	return en_options_cli_browse(inputs)
});